import Resource from './resource';
import { createMemoizedHtmlWidthDangerously } from 'components/common/size_helpers';

function createWidthCalculatorFunctions(fontSize) {
  return {
    getBarLabelHtmlWidth: createMemoizedHtmlWidthDangerously(
      fontSize,
      'bar-label',
      null,
      '10000px'
    ),
    getLimitedHtmlWidth: createMemoizedHtmlWidthDangerously(
      fontSize,
      'timeline-row-name-wrapper',
      null,
      // This has to be the exact same width as the inner contents of the
      // timeline-row-name-wrapper that is actually rendered. As of writing this,
      // the timeline-row-name-wrapper is 150px (when font size is 12) with
      // box-sizing: border-box and 8px of padding. That means the inner
      // contents are 134px wide. But! There is a really strange behaviour where
      // sometimes the font awesome icon is not yet showing, and that, despite
      // having a fixed width, causes the text to wrap differently.
      `${(fontSize - 12) * 12 + 150 - 20}px` // Timeline-column-width calculation
    ),
    getRelatedRecordIconWidth: () => {
      // At 12px font size, there is 6px margin, 6px padding, and the
      // icon is 24px wide.
      // At 14px font size, there is 7px margin, 7px padding, and the
      // icon is 26px wide.
      // Extrapolate from there.
      return fontSize * 2 + 12;
    },
  };
}

// Class representing the entire tree.
class ResourceTree {
  constructor(resourceData, timelineType, fontSize = 12) {
    this.timelineType = timelineType;
    this.tree = [];
    this.rows = [];

    const widthCalculators = createWidthCalculatorFunctions(fontSize);

    resourceData.forEach((data, progenitorIndex) => {
      const node = new Resource(
        data.label,
        data,
        this.timelineType,
        this,
        progenitorIndex, // `progenitorIndex` is the top-most node's index within the top-most level nodes.
        widthCalculators
      );
      return this.tree.push(node);
    });
  }

  addRows(rows) {
    return (this.rows = this.rows.concat(rows));
  }

  depth() {
    if (this.tree.length > 0) {
      return this.tree[0].totalDepth();
    } else {
      return 0;
    }
  }

  heightOfRows(compactView, minDate, maxDate, thickBars, fontSize) {
    return this.tree.reduce((height, resource) => {
      return (
        height +
        resource.heightOfRows(
          compactView,
          0,
          minDate,
          maxDate,
          thickBars,
          fontSize
        )
      );
    }, 0);
  }
}

export default ResourceTree;
